import { ReviewStatus } from "../constants/dealer-basic-data";

export class ReviewReply {

    dealerId: string = "";
    date: string = "";
    comment: string = "";
    status: ReviewStatus = ReviewStatus.TO_CHECK;

    constructor(){
        
    }
 }